import * as React from 'react';
import { connect } from 'react-redux';
import {
    Collapse,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Nav,
    Navbar as BTNavbar,
    NavbarBrand,
    NavbarToggler,
    NavItem,
    UncontrolledDropdown
} from 'reactstrap';
import { logoutUser } from '../../../actions/loginActions';
import { getUserData, removeUserData } from '../../../services/utilityServices';
import { parseJwt } from '../../../utils/generalUtils';
import { Icon } from '../Icon';
import { CustomNavLink as NavLink } from './CustomNavLink';
import './navbar.scss';
import { UserModel } from '../../../model/UserModel';
import { getUserDetails } from '../../../services/userService';
import { Async } from '../Async';
const brandLogo = require('../../../images/LMS_eConnect_Crop.jpg');
const UserProfileImage = require('../../../images/UserProfile.png')
export interface INavbarProps {
    userInstance?: UserModel;
    userUID?: string;
    userImageURLBase64?: string;
    // orgLogoURLBase64?: string;
    // orgLogo?: string;
}

export interface INavbarState {
    isOpen: boolean;
}

export class NavbarImpl extends React.PureComponent<INavbarProps, INavbarState> {
    constructor(props: INavbarProps) {
        super(props);
        this.state = { isOpen: false };
    }

    public toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    public promise = async () => {
        if (!this.props.userInstance) {
            await getUserDetails(this.props.userUID);
        }
    }

    public handleLogout = () => {
        logoutUser();
        removeUserData();
    }

    public renderLoader = () => {
        return <div className="nav-item">
            <div className="spinner">
                {/* Loading... */}
                <div className="rect1" />
                <div className="rect2" />
                <div className="rect3" />
                <div className="rect4" />
                <div className="rect5" />
            </div>
        </div>;
    }

    public render() {
        const { userInstance } = this.props;
        const isSuperAdmin = UserModel.isSuperAdmin(this.props.userInstance);
        const isAdmin = UserModel.isAdmin(this.props.userInstance);
        const isTrainee = UserModel.isTrainee(this.props.userInstance);
        const logoURL = getUserData().LogoURL;
        const userData = getUserData();
        const orgLogo = userData.LogoURL;
        return <BTNavbar light expand="lg">
            <NavbarBrand href="/#/home"><img src={brandLogo} height="64px" width="125px" alt="Training Module" /></NavbarBrand>
            {orgLogo && (
    <NavbarBrand href="/#/home">
        <img
            src={orgLogo}
            height="64px"
            width="125px"
            alt="Org-logo"
            onError={(e) => {
                e.currentTarget.style.display = 'none';
            }}
            style={{
                display: 'block',
                height: '64px',
                width: '125px',
                objectFit: 'contain'
            }}
        />
    </NavbarBrand>
)}
            {/* {logoURL && <NavbarBrand href="/#/home"><img src={this.props.orgLogo ? this.props.orgLogo : logoURL} height="64px" width="125px" alt="Org-logo"/></NavbarBrand>} */}
            <NavbarToggler onClick={this.toggle} />
            <Collapse className="navbar-desktop" isOpen={this.state.isOpen} navbar>
                <Nav className="ml-auto" navbar>
                    <NavItem>
                        <NavLink to="/home">
                            <Icon icon="home" size="2x" />&nbsp;Home
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink to="/training/list">
                            <Icon icon="chalkboard-teacher" size="2x" /> &nbsp;Training
                        </NavLink>
                    </NavItem>
                    {isSuperAdmin &&
                        <NavItem>
                            <NavLink to="/org/list">
                                <Icon icon="building" size="2x" /> &nbsp;Organizations
                            </NavLink>
                        </NavItem>}
                    {/* {(isAdmin || isSuperAdmin || isTrainee) && <NavItem>
                        <NavLink to="/training/list">
                            <Icon icon="chalkboard-teacher" size="2x"/> &nbsp;Training
                        </NavLink>
                    </NavItem>} */}
                    {isAdmin &&
                        <NavItem>
                            <NavLink to="/user-module/list">
                                <Icon icon="user-tag" size="2x" /> &nbsp;User Modules
                            </NavLink>
                        </NavItem>}
                    {(isSuperAdmin || isAdmin) &&
                        <NavItem>
                            <NavLink to="/users/list">
                                <Icon icon="user-circle" size="2x" /> &nbsp;Users
                            </NavLink>
                        </NavItem>}
                    {isAdmin && <NavItem>
                        <NavLink to="/dashboard">
                            <Icon icon="chart-pie" size="2x" />&nbsp;Dashboard
                        </NavLink>
                    </NavItem>}
                    {(isAdmin || isTrainee) && <NavItem>
                        <NavLink to={`/certificates/${this.props.userUID}`}>
                            <Icon icon="certificate" size="2x" />&nbsp;
                            {isAdmin ? 'Certificates' : 'My Certificates'}
                        </NavLink>
                    </NavItem>}
                    {(isSuperAdmin) && <NavItem>
                        <NavLink to={`/libraryrequest/${this.props.userUID}`}>
                            <Icon icon="chalkboard" size="2x" />&nbsp;
                            Library Requests
                        </NavLink>
                    </NavItem>}
                    <Async
                        identifier="Navbar"
                        promise={this.promise}
                        loader={this.renderLoader()}
                        content={<UncontrolledDropdown nav inNavbar>
                            <DropdownToggle nav caret>
                                <div className="display-image">
                                    <img src={this.props.userImageURLBase64 ||
                                        (this.props.userInstance && this.props.userInstance.props.UserImage ? this.props.userInstance.props.UserImage + '?expires=' + Date.now(): UserProfileImage)}
                                        onError={(e) => {
                                            e.currentTarget.src = UserProfileImage;
                                        }}
                                        alt="User Profile" />
                                    {userInstance && userInstance.props.FirstName}
                                </div>
                            </DropdownToggle>
                            <DropdownMenu right>
                                <DropdownItem tag={NavLink} to={`/user-profile/${this.props.userUID}`}>
                                    <Icon icon="user-circle" /> &nbsp;User Profile
                                </DropdownItem>
                                <DropdownItem tag={NavLink}
                                    to={`/update-password/${userInstance && userInstance.props.Email}`}>
                                    <Icon icon="sign-out-alt" /> &nbsp;Update Password
                                </DropdownItem>
                                <DropdownItem tag={NavLink}
                                    to={`/user-feedback/${userInstance && userInstance.props.Id}`}>
                                    <Icon icon="comments" /> &nbsp;Feedback
                                </DropdownItem>
                                <DropdownItem tag={NavLink} to="/" onClick={this.handleLogout}>
                                    <Icon icon="sign-out-alt" /> &nbsp;Logout
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>}
                        error={<div>Error</div>}
                    />
                </Nav>
            </Collapse>
        </BTNavbar>;
    }
}

export function mapStateToProps(state) {
    const userUID = state.login.get('token') ? parseJwt(state.login.get('token')).UniqueID : getUserData().userUID;
    // const orgLogo = state.miscellaneous.get('orgImageBase64') ? state.miscellaneous.get('orgImageBase64') : getUserData().LogoURL;
    return {
        userUID,
        userInstance: UserModel.get(userUID),
        userImageURLBase64: state.miscellaneous.get('userImageBase64'),
        // orgLogo
    };
}

export const Navbar = connect<{}, {}, INavbarProps>(mapStateToProps)(NavbarImpl);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/Navbar/index.tsx